// src/components/Header.js
import React from "react";
import { NavLink, Link, useNavigate } from "react-router-dom";

export default function Header({ user, onLogout }) {
  const navigate = useNavigate();

  function handleLogout() {
    try {
      onLogout?.(); // App will clear localStorage
    } finally {
      navigate("/login", { replace: true });
    }
  }

  const activeStyle = ({ isActive }) => ({
    color: isActive ? "#6ee7b7" : "#fff",
    textDecoration: "none"
  });

  return (
    <header
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "0 40px",
        background: "#0a2348",
        height: "60px",
        color: "#fff"
      }}
      role="banner"
    >
      <Link
        to="/"
        style={{
          fontWeight: "bold",
          fontSize: "1.4em",
          color: "#6ee7b7",
          textDecoration: "none"
        }}
        aria-label="TrakieBC Home"
      >
        TrakieBC
      </Link>

      <nav aria-label="Main navigation">
        <ul
          style={{
            display: "flex",
            gap: "24px",
            listStyle: "none",
            margin: 0,
            padding: 0
          }}
        >
          <li><NavLink to="/bc-list"         style={activeStyle}>BC List</NavLink></li>
          <li><NavLink to="/pending-bc"      style={activeStyle}>Pending BC</NavLink></li>
          <li><NavLink to="/variance-match"  style={activeStyle}>Variance - Match</NavLink></li>
          <li><NavLink to="/variance-unmatch"style={activeStyle}>Variance - Unmatch</NavLink></li>
          <li><NavLink to="/berita-acara"    style={activeStyle}>Berita Acara</NavLink></li>
        </ul>
      </nav>

      <div>
        <span style={{ marginRight: 12 }}>
          Hi, {user?.FullName || user?.Username || user?.username || "User"}
        </span>
        <button
          type="button"
          onClick={handleLogout}
          style={{
            background: "#6ee7b7",
            border: "none",
            color: "#0a2348",
            padding: "5px 18px",
            borderRadius: "5px",
            fontWeight: "bold",
            cursor: "pointer"
          }}
          aria-label="Logout"
        >
          Logout
        </button>
      </div>
    </header>
  );
}
